import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { PortalAuthService } from '../../core/portal-auth.service';
import { WelcomeDialogComponent } from '../../core/welcome-dialog.component';
import { GUIDE_TOPICS } from '../../core/guide-content';
import { I18nService } from '../../core/i18n.service';

// The standing counterpart to the one-time welcome dialog — same topic
// descriptions (see guide-content.ts), reachable any time from the nav
// instead of only on first sign-in.
@Component({
  selector: 'portal-help',
  templateUrl: './help.component.html',
  styleUrls: ['./help.component.css']
})
export class HelpComponent {

  topics = GUIDE_TOPICS;

  private readonly ROLE_KEYS: { [role: string]: string } = {
    owner: 'help.roleOwner', manager: 'help.roleManager', viewer: 'help.roleViewer'
  };

  constructor(private auth: PortalAuthService, private dialog: MatDialog, private i18n: I18nService) { }

  get role(): string {
    const s = this.auth.session;
    return (s && s.user && s.user.role) || '';
  }

  get roleLabel(): string {
    const key = this.ROLE_KEYS[this.role];
    return key ? this.i18n.t(key) : '';
  }

  replayWelcome() {
    const s = this.auth.session;
    const user = (s && s.user) || {};
    this.dialog.open(WelcomeDialogComponent, {
      width: '560px',
      data: { name: user.name, role: user.role, rights: user.rights }
    });
  }
}
